<div fxLayout="row" fxFlex.xs>
	<img
		height="45"
		width="45"
		src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/organizedFor/public"
	/>
	<div fxLayout="column" fxFlexOffset.xs="3px" class="m-l-s">
		<mat-label i18n="@@createdBy_createdByLabel_oraganised"
			>Organised For:</mat-label
		>
		<div>{{ this.bankAccount?.account_name }}</div>
		<div>{{ this.bankAccount?.account_iban }}</div>
	</div>
</div>
